// extracted by mini-css-extract-plugin
export default {"container":"fN-z","topReviewHeading":"gN-z","criticalReview":"hN-z","favorableReview":"iN-z","vsSeparator":"jN-z"};